/// <reference path="runtime.d.ts" />

import 'core-js';
import * as $ from 'jquery';
import * as jqe from 'common/extensions/jqueryextensions';
import * as jqe2 from 'runtime/extensions/jqueryextensions';
import 'jquery-ui';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/position';
import 'jquery-ui/ui/widgets/button';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/menu';
import 'jquery-ui/ui/widgets/tabs';

import 'common/extensions/rxextensions';

import 'runtime/extensions/knockoutbindings';

import { IEventAggregator, EventAggregator, IDisposable, disposable, emptyDisposable, serialDisposable, disposableSubscription } from 'common/barrels/core';
import { div } from 'common/barrels/dom';
import { Request } from 'common/request';
import { StringResult } from 'common/stringresult';
import { Observable, AsyncSubject } from 'common/barrels/rx';
import { blockBusy } from 'common/dom/block';
import { DialogManager } from 'runtime/dialogmanager';
import { IResourceProvider } from 'common/resourceprovider';
import { getRequest } from 'common/requestidiom';

import { ResourceProvider } from 'shared/resourceprovider';
import { ConcurrencyCheckFailed } from 'shared/messages/concurrencycheckfailed';

import { ErrorReport } from 'runtime/errorreport';

import { Busy } from 'runtime/events/busy';
import { NotBusy } from 'runtime/events/notbusy';
import { GenericEvent } from 'runtime/events/genericevent';
import { RuntimeHostClosed } from 'runtime/events/runtimehostclosed';
import { SystemErrorMessage } from 'runtime/events/systemerrormessage';
import { RuntimeInfoRequested } from 'runtime/events/runtimeinforequested';

import { OpenReadOnlyWorkItemRequested } from 'runtime/events/openreadonlyworkitemrequested';
import { OpenWritableWorkItemRequested } from 'runtime/events/openwritableworkitemrequested';
import { CreateWorkItemRequested } from 'runtime/events/createworkitemrequested';
import { DialogRequested } from 'runtime/events/dialogrequested';

import { RuntimeInfo } from 'runtime/data/runtimeinfo';
import { WorkItemDataVersionPreference } from 'runtime/data/workitemdataversionpreference';
import { WorkItemViewInfo } from 'runtime/data/workitemviewinfo';

import * as path from 'shared/path';

import { RuntimeHost } from 'runtime/runtimehost';

import { AmbiguousDataVersion } from 'runtime/messages/ambiguousdataversion';
import { WorkItemNotAvailableForClaim } from 'runtime/messages/workitemnotavailableforclaim';
import { WorkItemNotFound } from 'runtime/messages/workitemnotfound';
import { WorkItemDiscarded } from 'runtime/messages/workitemdiscarded';
import { AmbiguousWorkItem } from 'runtime/messages/ambiguousworkitem';
import { WorkItemSecurityViolation } from 'runtime/messages/workitemsecurityviolation';

import { SystemError } from 'common/exceptions/systemerror';

import { WorkItemNotFoundDialog } from 'runtime/dialogs/workitemnotfounddialog';
import { WorkItemDiscardedDialog } from 'runtime/dialogs/workitemdiscardeddialog';
import { AmbiguousWorkItemDialog } from 'runtime/dialogs/ambiguousworkitemdialog';
import { GenericInfoDialog } from 'runtime/dialogs/genericinfodialog';
import { AmbiguousDataVersionDialog} from 'runtime/dialogs/ambiguousdataversiondialog';
import { OpenOptionsDialog, OpenOption } from 'runtime/dialogs/openoptionsdialog';
import { WorkItemChangedDialog, WorkItemChangedDialogMode } from 'runtime/dialogs/workitemchangeddialog';

import { CreateDefinition } from 'runtime/screens/createdefinition';
import { WorkTray } from 'runtime/screens/worktray';
import { WorkflowStatus } from 'runtime/screens/workflowstatus';
import { Search } from 'runtime/screens/search';
import { Delegation } from 'runtime/screens/delegation';
import { ProcessNotificationResponse } from './screens/processnotification';

import { Serializer } from 'common/serializer';
import { createSerializer } from 'runtime/serialization'
import { ViewProvider } from 'runtime/viewprovider';

import 'common/styles/normalize.less';
import 'common/styles/core.less';
import 'jquery-ui/themes/base/all.css';
import 'runtime/styles/jquery-ui/jquery-ui.overrides.less';
import 'runtime/styles/core.less';
import 'runtime/corecontrols';
import '@fontsource/inter/latin.css'

import { wireBusy } from 'common/dom/fluency';

declare var __webpack_require__: any;

const hardwiredUnlocalizedCouldNotLoadResourcesMessage = 'Failed to load application resources.';
const hardwiredUnlocalizedCouldNotLoadResourcesTitle = 'Critical Error';

$(() => {
    jqe.revertPrefilter();
    jqe.fixBrokenCleanData();
    jqe.augmentJQuery();
    jqe2.augmentJQuery();

    const serializer = createSerializer();
    const dependencies = getRequest(serializer, path.ui('runtimeinfo'), RuntimeInfo, x => x)
        .switchMap(ri =>
            getRequest(serializer, path.publicResources(`corestrings?c=${ri.culture || ''}&v=${ri.version}`), StringResult, r => ({ r: r.value, v: ri.version, c: ri.culture }))
                .map(res => ({
                    resources: new ResourceProvider(res.r, res.v, res.c),
                    runtimeInfo: ri
                }))
        );

    wireBusy(
        div('runtime-application-container application-container alert-container').appendTo($('body')),
        dependencies,
        (o, e) => o.subscribe(d => new App(e, serializer, d.resources, d.runtimeInfo), () => resourcesUnavailable())
    );

    (<any>window).load = __webpack_require__;
});

class App {
    private $host: JQuery;
    private eventAggregator: IEventAggregator;
    private subscriptions: IDisposable;
    
    private runtimeInfo: RuntimeInfo;
    private resources: IResourceProvider;
    private serializer: Serializer;

    private kioskSettings: any;

    private hostDisposable = serialDisposable(null);

    private blockDisposable = serialDisposable(null);

    private csrfToken: () => string;

    constructor(host: JQuery, serializer: Serializer, resources: IResourceProvider, runtimeInfo: RuntimeInfo) {
        (<any>window).unseemlyGlobalJQueryReference = $;

        this.$host = host;

        this.blockDisposable.set(blockBusy(this.$host));

        this.eventAggregator = new EventAggregator();

        this.resources = resources;
        this.runtimeInfo = runtimeInfo;
        this.serializer = serializer;

        this.csrfToken = () => this.runtimeInfo.csrfToken;

        new DialogManager(this.eventAggregator);

        this.loadStyles();

        this.subscriptions = disposableSubscription(
            this.installBackspaceBlocker(),
            this.installWindowErrorHandler(),
            this.eventAggregator.query(Busy).subscribe(x => this.blockDisposable.set(blockBusy(x.$element || this.$host))),
            this.eventAggregator.query(NotBusy).subscribe(() => this.blockDisposable.set(null)),
            this.eventAggregator.query(SystemErrorMessage).subscribe(x => new ErrorReport(this.resources, null, x.continueAction).addError()),
            this.eventAggregator.query(OpenReadOnlyWorkItemRequested).subscribe(x => this.openRead(x.workItemId, x.preference, x.stepFilter, x.closeWhenComplete)),
            this.eventAggregator.query(OpenWritableWorkItemRequested).subscribe(x => this.openEdit(x.workItemId, x.stepFilter, x.closeWhenComplete)),
            this.eventAggregator.query(CreateWorkItemRequested).subscribe(x => this.create(x.hash, x.closeWhenComplete)),
            this.eventAggregator.query(GenericEvent).filter(x => x.name === 'InitializeKiosk')
                .first()
                .map(x => JSON.parse(x.payload))
                .subscribe(x => {
                    this.kioskSettings = x;
                    this.resetKiosk();
                }),
            this.eventAggregator.query(GenericEvent).filter(x => x.name === 'InitializeKiosk')
                .first()
                .flatMap(x => this.eventAggregator.query(RuntimeHostClosed))
                .subscribe(() => this.resetKiosk()),
            this.eventAggregator.query(GenericEvent)
                .filter(() => (<any>window).boundAsync)
                .subscribe(x => (<any>window).boundAsync.messageHost(x.name, x.payload)),
            this.eventAggregator.query(RuntimeInfoRequested).map(y => ({ event: y, info: this.runtimeInfo })).subscribe(x => x.event.value = x.info)
        );

        var hash = window.location.hash;
        var actionParts = hash.split('/');
        var actionName = (actionParts[0] || '#').substr(1);

        // Regular expression to validate a UUID (version 4).
        const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        // If the second part of the action is not a UUID, treat it as a view name
        const view = actionParts[1] && !UUID_REGEX.test(actionParts[1]) ? actionParts[1] : null;
        // searchParams is used by some screens to prefill propeties
        const searchParams = actionParts.find(part => part.startsWith('?'));

        var unblock = x => { x(); this.blockDisposable.set(null); };
        var getFilter = () => decodeURIComponent(actionParts[2] || '');

        const legacyResourcesWrapper = Observable.of(this.resources);

        var actions = {
            'open': () => unblock(() => this.openEdit(actionParts[1], getFilter(), true)),
            'openread': () => unblock(() => this.openRead(actionParts[1], WorkItemDataVersionPreference.None, getFilter(), true)),
            'create': () => unblock(() => this.create(hash, true)),
            'worktray': () => new WorkTray(this.$host, legacyResourcesWrapper, this.eventAggregator, this.serializer, view, (view ? actionParts.slice(2) : actionParts.slice(1)).filter(x => !!x), this.csrfToken),
            'workflowstatus': () => new WorkflowStatus(this.$host, legacyResourcesWrapper, this.eventAggregator, this.serializer, view, this.csrfToken),
            'createdefinition': () => unblock(() => new CreateDefinition(this.$host, legacyResourcesWrapper, this.eventAggregator, this.serializer, this.csrfToken)),
            'search': () => new Search(this.$host, legacyResourcesWrapper, this.eventAggregator, this.serializer, view, searchParams, this.csrfToken),
            'delegation': () => new Delegation(this.$host, legacyResourcesWrapper, this.eventAggregator, this.serializer, this.csrfToken),
            'kiosk': () => unblock(() => this.kiosk()),
            'processresponse': () => new ProcessNotificationResponse(this.$host, legacyResourcesWrapper, this.eventAggregator, this.serializer, actionParts.slice(1), this.csrfToken)
        };

        (actions[actionName] || actions['worktray'])();
    }

    private kiosk() {
        (<any>window).boundAsync.ready((name, payload) => this.eventAggregator.publish(new GenericEvent(name, payload)));
    }

    private resetKiosk() {
        this.commonCreate(this.kioskSettings.DefinitionName, this.kioskSettings.FieldValues.map(x => ({ fieldName: x.Key, value: x.Value })));
    }

    private openEdit(workItemId: string, stepFilter: string, closeWhenComplete: boolean): void {
        this.applyCloseWhenComplete(closeWhenComplete);
        this.openWorkItem(workItemId, false, true, WorkItemDataVersionPreference.PreferSaved, stepFilter);
    }

    private openRead(workItemId: string, preference: WorkItemDataVersionPreference, stepFilter: string, closeWhenComplete: boolean): void {
        this.applyCloseWhenComplete(closeWhenComplete);
        this.openWorkItem(workItemId, true, false, preference, stepFilter);
    }

    private create(hash: string, closeWhenComplete: boolean): void {
        var parts = hash.indexOf('/') > -1
            ? hash.split(/\/|\?|&/)
            : ['', hash];

        var parseToKvp = x => {
            var a = x.split('=');
            return { fieldName: a[0], value: a[1] };
        };

        this.applyCloseWhenComplete(closeWhenComplete);

        this.commonCreate(parts.slice(1)[0], parts.slice(2).map(x => parseToKvp(x)));
    }

    private commonCreate(definitionName: string, initialValues: { fieldName: string, value: string }[]) {
        var source = new AsyncSubject<WorkItemViewInfo>();

        Request.create(this.serializer, path.ui('create'))
            .args(() => ({
                definitionName: definitionName,
                initialdata: initialValues
            }))
            .handle(WorkItemViewInfo, wivi => {
                source.next(wivi);
                source.complete();
            })
            .post(this.csrfToken());

        source.subscribe(x => this.hostDisposable.set(new RuntimeHost(this.$host, x, this.resources, this.eventAggregator, this.serializer, new ViewProvider(this.resources.version()), this.csrfToken, this.submittedViewUrl())));
    }

    private openWorkItem(workItemId: string, readOnly: boolean, autoClaim: boolean, preference: WorkItemDataVersionPreference, stepFilter: string): void {
        const blocker = blockBusy(this.$host, 'runtimehost-blocker');

        const url = path.ui(`open/${workItemId}`);

        Request.create(this.serializer, url)
            .args(() => ({ readOnly: readOnly, autoClaim: autoClaim, preference: preference, stepFilter: stepFilter }))
            .handle(WorkItemViewInfo, wivi => this.initializeHost(wivi, this.resources))
            .handle(AmbiguousDataVersion, () => this.handleAmbiguousDataVersion(workItemId, stepFilter))
            .handle(WorkItemNotAvailableForClaim, x => this.handleNotAvailableForClaim(x, stepFilter))
            .handle(SystemError, x => this.eventAggregator.publish(new SystemErrorMessage(x, () => this.resumeHost())))
            .handle(WorkItemNotFound, () => this.eventAggregator.publish(new DialogRequested(new WorkItemNotFoundDialog(this.resources, () => this.resumeHost()))))
            .handle(WorkItemDiscarded, () => this.eventAggregator.publish(new DialogRequested(new WorkItemDiscardedDialog(this.resources, () => this.resumeHost()))))
            .handle(AmbiguousWorkItem, () => this.eventAggregator.publish(new DialogRequested(new AmbiguousWorkItemDialog(this.resources, () => this.resumeHost()))))
            .handle(WorkItemSecurityViolation, () => this.eventAggregator.publish(new DialogRequested(new GenericInfoDialog(this.resources.getCoreString('WorkItemSecurityViolationDialogTitle'), this.resources.getCoreString('WorkItemSecurityViolationDialogText')))))
            .error((jqXhr: JQueryXHR, textStatus: string, errorThrown: string) => this.httpError(jqXhr, textStatus, errorThrown))
            .final(() => blocker.dispose())
            .post(this.csrfToken());
    }

    private resumeHost = () => {
        this.eventAggregator.publish(new RuntimeHostClosed());
    }

    private httpError = (jqXhr: JQueryXHR, textStatus: string, errorThrown: string): void => {
        new ErrorReport(this.resources, null, () => this.resumeHost()).addError({ message: errorThrown });
    }

    private handleAmbiguousDataVersion(workItemId: string, stepFilter: string) {
        this.eventAggregator.publish(new DialogRequested(new AmbiguousDataVersionDialog(this.resources, x => this.openWorkItem(workItemId, true, false, x, stepFilter), () => this.resumeHost())));
    }

    private handleNotAvailableForClaim(message: WorkItemNotAvailableForClaim, stepFilter: string) {
        var action = (dialogResult: OpenOption) => {
            switch (dialogResult) {
                case OpenOption.OpenReadOnly:
                    var pref = message.workItemInfo.state === 'claimed' ? WorkItemDataVersionPreference.None : WorkItemDataVersionPreference.PreferSubmitted;
                    this.openWorkItem(message.workItemInfo.workItemId, true, false, pref, stepFilter);
                    break;
                case OpenOption.TransferAndEdit:
                case OpenOption.ForceCancelAndEdit:
                    var actionPath = dialogResult === OpenOption.TransferAndEdit ? 'transferToSelfAndOpen' : 'forceCancelAndOpen'
                    Request.create(this.serializer, path.ui(`${actionPath}/${message.workItemInfo.workItemId}`))
                        .args(() => ({ workItemVersionId: message.workItemInfo.versionId }))
                        .handle(WorkItemViewInfo, x => this.initializeHost(x, this.resources))
                        .handle(ConcurrencyCheckFailed, () => this.eventAggregator.publish(new DialogRequested(new WorkItemChangedDialog(WorkItemChangedDialogMode.Generic, () => this.resumeHost(), this.resources))))
                        .handle(SystemError, x => this.eventAggregator.publish(new SystemErrorMessage(x, () => this.resumeHost())))
                        .error((jqXhr: JQueryXHR, textStatus: string, errorThrown: string) => this.httpError(jqXhr, textStatus, errorThrown))
                        .post(this.csrfToken());
                    break;
            }
        };

        this.eventAggregator.publish(new DialogRequested(new OpenOptionsDialog(this.resources, message, action, () => this.resumeHost())));
    }

    private initializeHost(wivi: WorkItemViewInfo, resources: IResourceProvider) {
        new RuntimeHost(this.$host, wivi, resources, this.eventAggregator, this.serializer, new ViewProvider(resources.version()), this.csrfToken, this.submittedViewUrl());
    }

    // A kiosk is shared: no link to the previous visitor's request may remain on screen.
    private submittedViewUrl(): (workItemId: string) => string {
        return this.kioskSettings
            ? null
            : workItemId => `${window.location.pathname}${window.location.search}#openread/${encodeURIComponent(workItemId)}`;
    }

    private applyCloseWhenComplete(closeWhenComplete: boolean) {
        if (!closeWhenComplete)
            return;

        this.eventAggregator.query(RuntimeHostClosed).filter(x => !x.suppressTeardown).subscribe(() => {
            div().text(this.resources.getCoreString('MsgOperationCompletePleaseCloseThisWindow')).appendTo($('body'));
            window.close();
        });
    }

    private loadStyles() {
        $('head').append(`<link rel="stylesheet" type="text/css" href="${path.publicResources(`styles?v=${this.runtimeInfo.version}`)}">`);
    }

    private installBackspaceBlocker() {
        // application-wide backspace interceptor to prevent navigating back. Blocking default browser behaviour is contentious, but it is the author's opinion that the number of users
        // who will accidentally lose their changes greatly outnumber those who intended to navigate back.

        var handler = event => {
            var e = event.target;

            if (event.which === $.ui.keyCode.BACKSPACE
                && !is(e, HTMLInputElement, x => !(x.disabled || x.readOnly) && (x.type.toLowerCase() === 'text' || x.type.toLowerCase() === 'password'))
                && !is(e, HTMLTextAreaElement, x => !(x.disabled || x.readOnly))
            ) {
                event.preventDefault();
            }
        };

        $(document).on('keydown', handler);

        return disposable(() => $(document).off(handler));
    }

    private installWindowErrorHandler(): IDisposable {
        var existingHandler = window.onerror;

        var processingError = false;

        window.onerror = (message: string, url?: string, line?: number, column?: number) => {
            if (processingError)
                return;

            processingError = true;
            new ErrorReport(this.resources, this.resources.getCoreString('BrowserErrorTitle')).addError({ message: this.resources.getCoreString('BrowserErrorMessage') });
            processingError = false;
        };

        return disposable(() => window.onerror = existingHandler);
    }

    dispose() {
        this.hostDisposable.dispose();
        this.subscriptions.dispose();
        this.blockDisposable.dispose();
    }
}

function is<T>(o: any, type: { new(): T }, condition ?: (x: T) => boolean): boolean {
    return o instanceof type && (!condition || condition(o));
}

function resourcesUnavailable() {
    div().append(
        div().height('100%').css('border', '5px outset red').css('padding', '10px').append(
            $('<h3 />').css('margin-top', '0').text(hardwiredUnlocalizedCouldNotLoadResourcesMessage)
        )
    ).dialog({
        width: 640,
        height: 480,
        title: hardwiredUnlocalizedCouldNotLoadResourcesTitle,
        modal: true,
        resizable: false
    });
}